import { Stack, Typography, styled } from "@mui/material";
import { colors } from "@zapalacorp/tokens";

export const Required = styled("span")(() => ({
  color: colors.error500,
  fontFamily: "Manrope",
  fontSize: "16px",
  fontWeight: 700,
  lineHeight: "24px",
  letterSpacing: "0.15px",
}));

interface ContainerProps {
  hasError?: boolean;
}

export const Container = styled("div")(({ hasError = false }: ContainerProps) => ({
  display: "flex",
  padding: "24px",
  flexDirection: "column",
  alignItems: "flex-start",
  gap: "24px",
  alignSelf: "stretch",
  borderRadius: "12px",
  background: colors.gray100,
  height: "100%",
  border: hasError ? `1px solid ${colors.error500}` : "none",
}));

export const Content = styled("div")(() => ({
  backgroundColor: colors.white,
  padding: "8px 0px",
  width: "100%",
  borderRadius: "8px",
  gap: "16px",
}));

export const StackRowContent = styled(Stack)(() => ({
  padding: "8px 16px",
}));

export const StackTextEnd = styled(Stack)(() => ({
  textAlign: "end",
}));

export const Line = styled("div")(() => ({
  height: "1px",
  backgroundColor: colors.gray200,
}));

export const Title = styled(Typography)(() => ({
  fontFamily: "Manrope",
  fontSize: "16px",
  fontStyle: "normal",
  fontWeight: 700,
  lineHeight: "24px",
  letterSpacing: "0.15px",
}));

export const TitleContainer = styled("div")(() => ({
  display: "flex",
  alignItems: "center",
  gap: "8px",
}));

export const TextVolume = styled(Typography)(() => ({
  fontFamily: "Manrope",
  fontSize: "16px",
  fontStyle: "normal",
  fontWeight: 600,
  lineHeight: "24px",
  letterSpacing: "0.15px",
  color: colors.gray600,
}));

export const InfoText = styled("span")(() => ({
  fontFamily: "Manrope",
  fontSize: "14px",
  fontStyle: "normal",
  fontWeight: 400,
  lineHeight: "20px",
  letterSpacing: "0.1px",
  color: colors.gray500,
}));

export const SubTitleInfo = styled(Typography)(() => ({
  fontFamily: "Manrope",
  fontSize: "14px",
  fontStyle: "normal",
  lineHeight: "20px",
  letterSpacing: "0.1px",
  color: colors.brandBlue500,
}));
